import { useSendAuthLink } from "./useSendAuthLink"

export type SendResetPasswordPayload = {
  email: string
}

type SendAuthLinkMutate = ReturnType<typeof useSendAuthLink>["mutate"]

export const useSendResetPassword = () => {
  const sendAuthLink = useSendAuthLink()

  return {
    mutate: (payload: SendResetPasswordPayload, options?: Parameters<SendAuthLinkMutate>[1]) => {
      return sendAuthLink.mutate(
        {
          email: payload.email,
          linkType: "recovery",
        },
        options,
      )
    },
    mutateAsync: (payload: SendResetPasswordPayload) => {
      return sendAuthLink.mutateAsync({
        email: payload.email,
        linkType: "recovery",
      })
    },
    isPending: sendAuthLink.isPending,
    isError: sendAuthLink.isError,
    isSuccess: sendAuthLink.isSuccess,
    error: sendAuthLink.error,
    data: sendAuthLink.data,
    reset: sendAuthLink.reset,
  }
}
